import flow from 'lodash/fp/flow';
import getOr from 'lodash/fp/getOr';
import invoke from 'lodash/fp/invoke';

export const getTotalCount = key =>
  flow(
    getOr(0, key),
    invoke('toLocaleString'),
  );
